<template>
  <v-dialog
    v-model="dialogVisible"
    persistent
    max-width="600"
    @keydown.esc="$emit('on-close')"
  >
    <v-card>
      <v-card-title class="dialog-card-title">
        <h2 class="subtitle-1">
          {{ title }}
        </h2>
      </v-card-title>

      <v-card-text class="content overflow-auto">
        <v-alert
          dense
          outlined
          type="warning"
          prominent
          color="gray"
          elevation="2"
          class="text-center"
          style="border: none !important; box-shadow: none !important; color: #000 !important;"
        >
          <slot></slot>
        </v-alert>
      </v-card-text>

      <v-card-actions class="dialog-card-footer">
       
        <v-btn color="black" depressed outlined @click="$emit('on-cancel')" class="button">
          Cancelar
        </v-btn>
        <v-btn color="success" depressed outlined @click="$emit('on-submit')" class="button">
          Sim
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CustomModal",
  props: {
    value: Boolean,
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  min-height: 10.5vh;
  max-height: 68vh;
  padding: 2rem;
}

.v-dialog > .v-card > .v-card__text {
  padding: 2rem;
}

.dialog-card-title {
  background-image: url('../../assets/mc_template.png');
  background-size: cover;
  background-position: center;
  padding-top: 2rem !important;
}

.dialog-card-footer {
  display: flex !important;
  justify-content: space-between !important;
  width: 100% !important;
}

.button {
  border: none !important;
  text-decoration: underline;
  text-transform: none;
}

</style>
